<template>
  <!--文章推荐页面-->
  <tk-container
    infiniteScroll
    class="container-wrap"
    @loadingMore="recommendedArticle"
  >
    <my-header slot="header">{{$route.query.type | pageTitle}}</my-header>
    <div
      class="b-g-f"
      v-for="(s, index) in recommendedArticleData"
      @click="$push({ path: '/common/articleDetail', query: { type: $route.query.type, id: s.objectId } })"
      :key="index"
    >
      <!--不为购买推荐类型-->
      <article-single v-if="$route.query.type !== 'buyRecommendation'" :article-single="s" :article-index="index"></article-single>
      <!--购买推荐类型-->
      <div
        v-else
        class="p-12 full-width"
        :style="{ paddingTop: index > 0 ? '0 !important' : '12px !important' }"
      >
        <tk-flex>
          <div class="tk-grid-4">
            <div
              class="content-box-br"
              @click.stop="viewImage(s)"
            >
              <tk-image class="content-box-br-img" :quality="100" :src="getArticleImage(s.IntroductionEvent)[0]" height="110"></tk-image>
            </div>
          </div>
          <tk-flex column class="tk-grid-8 m-l-12">
            <tk-flex middle class="full-width font-bold font-16">
              <span class="article-top" v-if="s.isTop">置顶</span>
              <span class="fill van-ellipsis font-14">{{s.articleTitle}}</span>
            </tk-flex>
            <div class="caption content-box-br-html m-t-10" v-html="getArticleText(s.IntroductionEvent)"></div>
          </tk-flex>
        </tk-flex>
        <tk-flex between bottom class="full-width p-t-12">
          <div class="caption">{{s.createdAt | datetime}}</div>
          <tk-flex right class="caption">
            <div>{{(s.readingSum ? s.readingSum : 0) | transform}}阅读</div>
            <div class="m-l-15">{{(s.reviewsPostsList && s.reviewsPostsList.length ? s.reviewsPostsList.length : 0) | transform}}评论</div>
          </tk-flex>
        </tk-flex>
      </div>
    </div>
    <!--查看大图组件-->
    <view-big-image
      ref="buySingle"
      :watch-num="watchNum"
      v-if="articleSingle && getArticleImage(articleSingle.IntroductionEvent)"
      :commodity-image="[getArticleImage(articleSingle.IntroductionEvent)[0]]"
    ></view-big-image>
  </tk-container>
</template>

<script>
import articleSingle from '@/components/articleSingle'
import viewBigImage from '@/components/viewBigImage'
export default {
  components: {
    articleSingle,
    viewBigImage
  },
  data () {
    return {
      watchNum: 0, // 查看大图索引
      articleSingle: null, // 点击的文章
      recommendedArticleData: [] // 文章推荐数据
    }
  },
  filters: {
    pageTitle (val) {
      if (val === 'buyRecommendation') { return '购买推荐' }
      if (val === 'excellentCases') { return '经营案例' }
      if (val === 'news') { return '产业资讯' }
      if (val === 'importantNotice') { return '重要通知' }
      return ''
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.setStatusBar('dark')
  },
  methods: {
    /**
     * 获取html中的文字
     * @date: 2020/3/23
     */
    getArticleText (html) {
      // return html.replace(/<\/?(img)[^>]*>/gi, '')
      let value = html.replace(/<\/?(img)[^>]*>/gi, '')
      let reg = /[\u4e00-\u9fa5]/g
      let names = value.match(reg)
      let val = names.join('')
      if (val.length > 30) {
        return val.substring(0, 30) + '...'
      }
      return value
    },
    /**
     * 获取html中的图片
     * @date: 2020/3/23
     */
    getArticleImage (str) {
      let list = []
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function (
          match,
          capture
        ) {
          list.push(capture)
        })
      if (!list.length) { return [''] }
      return list
    },
    /**
    * 查看大图
    * @date: 2020/9/15
    */
    async viewImage (s) {
      this.articleSingle = s
      await this.$tkHelper.sleep(0)
      await this.$refs.buySingle.showImages()
    },
    /**
     * 文章推荐
     * @date: 2020/4/9
     */
    async recommendedArticle (page, next) {
      let recommendedArticle = await this.$tkParse.getList(`/classes/${this.$route.query.type}`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-isTop, -createdAt'
        }
      })
      this.recommendedArticleData = [...this.recommendedArticleData, ...recommendedArticle]
      if (recommendedArticle.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    }
  },
  hasFlash () { // 更新文章
    let article = this.$getFlash('updateArticle')
    if (article) {
      let index = this.recommendedArticleData.findIndex(s => { return s.objectId === article.objectId })
      if (index !== -1) {
        this.recommendedArticleData[index].readingUser = article.readingUser
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /*置顶样式*/
  .article-top {
    display: inline-block;
    min-width: 28px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    background: rgba(247, 223, 223, 1);
    border-radius: 2px;
    font-size: 11px;
    color: rgba(207, 22, 19, 0.9);
    margin-right: 2px;
  }
  /*文章图片样式*/
  .content-box-br {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    overflow: hidden;
    position: relative;
  }
  .content-box-br-img {
    /*border-radius: 5px;*/
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .content-box-br-html {
    background-color: #F9FBFC;
    border-radius: 5px;
    width: 100%;
    display: table-cell;
    text-align: justify;
    font-size: 14px !important;
    padding: 9px;
    /*height: 75px;*/
    ::v-deep p {
      span {
        font-size: 14px !important;
      }
    }
  }
</style>
